import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HERO_SLIDES } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export function Hero() {
  const [index, setIndex] = useState(0);
  const content = useContent();

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % HERO_SLIDES.length), 5500);
    return () => clearInterval(t);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" data-testid="hero-section" className="relative h-[92vh] md:h-screen w-full overflow-hidden">
      {HERO_SLIDES.map((slide, i) => (
        <div
          key={slide.url}
          className="hero-slide absolute inset-0"
          style={{ opacity: i === index ? 1 : 0, zIndex: i === index ? 1 : 0 }}
        >
          <img src={slide.url} alt={slide.label} className="w-full h-full object-cover" />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-t from-epic-black via-epic-black/50 to-epic-black/30 z-10" />

      <div className="relative z-20 h-full max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-24 md:pb-28">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <h1 className="font-display text-white text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-[0.88] mt-5 max-w-5xl">
            {content.hero_title}
          </h1>
          <p className="text-epic-gray text-lg md:text-2xl mt-6 max-w-2xl font-light">
            {content.hero_subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-9">
            <button
              data-testid="hero-view-events"
              onClick={() => go("events")}
              className="bg-epic-gold text-epic-black font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-epic-goldhover transition-colors duration-300"
            >
              View Upcoming Events
            </button>
            <button
              data-testid="hero-book-venue"
              onClick={() => go("booking")}
              className="border border-epic-gold text-epic-gold bg-transparent hover:bg-epic-gold hover:text-epic-black font-bold uppercase tracking-widest text-sm px-8 py-4 transition-colors duration-300"
            >
              Book The Venue
            </button>
          </div>
        </motion.div>
      </div>

      {/* slide indicators */}
      <div className="absolute bottom-8 right-6 md:right-12 z-20 flex gap-2">
        {HERO_SLIDES.map((slide, i) => (
          <button
            key={`dot-${slide.url}`}
            data-testid={`hero-dot-${i}`}
            onClick={() => setIndex(i)}
            className={`h-1 transition-all duration-500 ${i === index ? "w-10 bg-epic-gold" : "w-5 bg-white/30"}`}
          />
        ))}
      </div>
    </section>
  );
}
